import React from "react";
import { Loader2 } from "lucide-react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center" data-testid="auth-loading">
        <Loader2 className="animate-spin text-inkSoft" size={20} />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
